import * as yup from "yup";

export const filterSchema = yup.object().shape({
  dateRangeFrom: yup.string(),
  dateRangeTo: yup
    .string()
    .test(
      "is-greater-or-equal",
      "To must be greater than From",
      function (value) {
        const { dateRangeFrom } = this.parent;
        return !dateRangeFrom || !value || value >= dateRangeFrom;
      },
    ),
  status: yup.string().required("Status is required"),
  volumeCapFrom: yup
    .number()
    .required("Volume cap from is required")
    .min(0, "Must be greater than 0"),
  volumeCapTo: yup
    .number()
    .required("Volume cap to is required")
    .min(0, "Must be greater than 0")
    .test(
      "is-greater-or-equal",
      "To must be greater than From",
      function (value) {
        const { volumeCapFrom } = this.parent;
        return !volumeCapFrom || !value || value >= volumeCapFrom;
      },
    ),
  volumeUsedFrom: yup
    .number()
    .required("Volume used from is required")
    .min(0, "Must be greater than 0"),
  volumeUsedTo: yup
    .number()
    .required("Volume used to is required")
    .min(0, "Must be greater than 0")
    .test(
      "is-greater-or-equal",
      "To must be greater than From",
      function (value) {
        const { volumeUsedFrom } = this.parent;
        return !volumeUsedFrom || !value || value >= volumeUsedFrom;
      },
    ),
  volumeMTDFrom: yup
    .number()
    .required("Volume MTD from is required")
    .min(0, "Must be greater than 0"),
  volumeMTDTo: yup
    .number()
    .required("Volume MTD to is required")
    .min(0, "Volume MTD to must be greater than 0")
    .test(
      "is-greater-or-equal",
      "To must be greater than From",
      function (value) {
        const { volumeMTDFrom } = this.parent;
        return !volumeMTDFrom || !value || value >= volumeMTDFrom;
      },
    ),
  momChangeFrom: yup
    .number()
    .required("MOM change from is required")
    .min(0, "Must be greater than 0"),
  momChangeTo: yup
    .number()
    .required("MOM change to is required")
    .min(0, "Must be greater than 0")
    .test(
      "is-greater-or-equal",
      "To must be greater than From",
      function (value) {
        const { momChangeFrom } = this.parent;
        return !momChangeFrom || !value || value >= momChangeFrom;
      },
    ),
});
